export default "__VITE_ASSET__CRnY1G6a__"